import services from '@/services/ascentiaServiceIndex'
import { ANALYTIC_MANAGEMENT_CONSTS as AMC } from '../consts'

const state = {
  analyticsData: [],
  allAnalyticsLoading: false,
  analyticDetails: {},
  isAnalyticDetailsLoading: false,
  isSaveAnalyticsLoading: false,
  toastNotification: true,
}

const getters = {}

const mutations = {
  [AMC.UPDATE_ALL_ANALYTICS]: (state, data) => (state.analyticsData = data),
  [AMC.ALL_ANALYTICS_LOADING]: (state, data) =>
    (state.allAnalyticsLoading = data),
  [AMC.UPDATE_ANALYTIC_DETAILS]: (state, data) =>
    (state.analyticDetails = data),
  [AMC.UPDATE_ANALYTIC_DETAILS_LOADING]: (state, data) =>
    (state.isAnalyticDetailsLoading = data),
  [AMC.SAVE_ANALYTIC_DETAILS_LOADING]: (state, data) =>
    (state.isSaveAnalyticsLoading = data),
  [AMC.TOAST_NOTIFICATION]: (state, data) => (state.toastNotification = data),
}

const actions = {
  async [AMC.GET_ALL_ANALYTICS]({ commit }, args = { refresh: false }) {
    commit(AMC.ALL_ANALYTICS_LOADING, true)
    try {
      const response = await services.analyticManagement.getData(
        'allAnalytics',
        null,
        args.refresh,
      )
      const data = response.data
      commit(AMC.UPDATE_ALL_ANALYTICS, data)
    } catch (error) {
      console.log(`${[AMC.GET_ALL_ANALYTICS]}: error ${error}`)
    }
    commit(AMC.ALL_ANALYTICS_LOADING, false)
  },
  async [AMC.GET_ANALYTIC_DETAILS]({ commit }, analyticId) {
    commit(AMC.UPDATE_ANALYTIC_DETAILS_LOADING, true)
    try {
      const response = await services.analyticManagement.getData(
        'analyticDetails',
        analyticId,
        true,
      )
      const data = response.data
      commit(AMC.UPDATE_ANALYTIC_DETAILS, data)
    } catch (error) {
      console.log(`${[AMC.GET_ANALYTIC_DETAILS]}: error ${error}`)
      commit(AMC.UPDATE_ANALYTIC_DETAILS, {})
    }
    commit(AMC.UPDATE_ANALYTIC_DETAILS_LOADING, false)
  },
  async [AMC.SAVE_ANALYTIC_DETAILS]({ commit, dispatch }, analytic) {
    commit(AMC.TOAST_NOTIFICATION, false)
    commit(AMC.SAVE_ANALYTIC_DETAILS_LOADING, true)
    const response = await services.analyticManagement.saveData(
      'updateAnalyticDetails',
      analytic,
      true,
    )
    if (response.status === 200 && response.data === 1) {
      commit(AMC.TOAST_NOTIFICATION, true)
      dispatch(AMC.GET_ALL_ANALYTICS, { refresh: true })
    } else {
      commit(AMC.TOAST_NOTIFICATION, false)
    }
    commit(AMC.SAVE_ANALYTIC_DETAILS_LOADING, false)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
